var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-seven"},[_c('img',{staticClass:"logo-seven",attrs:{"src":` ${
        _vm.restaurant.logo
          ? 'htttp://localhost:3333/logos/' + _vm.restaurant.logo
          : 'htttp://localhost:3333/logos/logo.png'
      } `,"alt":""}}),_c('h2',{staticClass:"menuName-seven",domProps:{"textContent":_vm._s(_vm.newItem[_vm.currentLang] ? _vm.newItem[_vm.currentLang].name : '')}},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('p',{staticClass:"description-seven"},[_vm._v(" "+_vm._s(_vm.restaurant.observation ? _vm.restaurant.observation : "")+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }